import client from '../../../config/api';
import { SET_CURRENT_JOB } from '../../jobs/mutations/mutationTypes';

export default {
  async UPDATE_JOB_WATCHERS({ commit, rootState }, { jobId, watchers }) {
    try {
      const response = await client.put(`/job/${jobId}/watchers`, {
        watchers,
      });
      const updatedWatchers = response?.data?.watchers || watchers;

      commit(
        'SET_CURRENT_JOB',
        {
          ...(rootState.currentJob || {}),
          _id: jobId,
          watchers: updatedWatchers,
        },
        { root: true }
      );
      commit(
        SET_CURRENT_JOB,
        {
          ...(rootState.JobsModule?.currentJob || {}),
          _id: jobId,
          watchers: updatedWatchers,
        },
        { root: true }
      );

      return response.data;
    } catch (err) {
      console.error('Error updating watchers:', err);
      throw err;
    }
  },

  async SEND_JOB_NOTIFICATION(
    _context,
    { jobId, recipients, message, templateId }
  ) {
    try {
      const response = await client.post(`/job/${jobId}/notify`, {
        recipients,
        message,
        templateId,
      });
      return response.data;
    } catch (err) {
      console.error('Error sending notification:', err);
      throw err;
    }
  },

  async GET_JOB_NOTIFICATION_LOG(_context, { jobId }) {
    try {
      const response = await client.get(`/job/${jobId}/notification-log`);
      return response.data;
    } catch (err) {
      console.error('Error fetching notification log:', err);
      throw err;
    }
  },

  async GET_NOTIFICATION_TEMPLATES(_context, query = {}) {
    try {
      const response = await client.get('/notification-templates', {
        params: query,
      });
      return response.data || [];
    } catch (err) {
      console.error('Error fetching notification templates:', err);
      throw err;
    }
  },

  async GET_NOTIFICATION_EVENT_SETTINGS() {
    try {
      const response = await client.get('/notification-event-settings');
      return response.data || [];
    } catch (err) {
      console.error('Error fetching notification event settings:', err);
      throw err;
    }
  },

  async UPDATE_NOTIFICATION_EVENT_SETTING(_context, { eventKey, templateId }) {
    try {
      const response = await client.put(
        `/notification-event-settings/${eventKey}`,
        { templateId }
      );
      return response.data;
    } catch (err) {
      console.error('Error updating notification event setting:', err);
      throw err;
    }
  },

  async CREATE_NOTIFICATION_TEMPLATE(_context, payload) {
    try {
      const response = await client.post('/notification-templates', payload);
      return response.data;
    } catch (err) {
      console.error('Error creating notification template:', err);
      throw err;
    }
  },

  async UPDATE_NOTIFICATION_TEMPLATE(_context, payload) {
    try {
      const response = await client.patch(
        `/notification-templates/${payload._id}`,
        payload
      );
      return response.data;
    } catch (err) {
      console.error('Error updating notification template:', err);
      throw err;
    }
  },

  async ARCHIVE_NOTIFICATION_TEMPLATE(_context, { id }) {
    try {
      const response = await client.delete(`/notification-templates/${id}`);
      return response.data;
    } catch (err) {
      console.error('Error archiving notification template:', err);
      throw err;
    }
  },
};
